import { useMutation } from '@apollo/client/react';
import { Modal as AntModal, Form } from 'antd';
import styled from '@emotion/styled';

import { UPDATE_ACCOUNT_STATUS } from 'mutations/account';
import { BREAKPOINT } from 'utilities/constants';
import { resetApplyStatusState, useApplyStatusState } from './applyStatusState';

const Modal = styled(AntModal)`
  min-width: 100%;

  @media (min-width: ${BREAKPOINT.MD_PX}) {
    min-width: 740px;
  }
`;

const ApplyStatusModal = ({ hide, ...modalProps }) => {
  const [form] = Form.useForm();

  const { currentStep } = useApplyStatusState();

  const [setAccountFraudStatus, accountStatusMutation] = useMutation(
    UPDATE_ACCOUNT_STATUS,
  );

  const closeModal = () => {
    resetApplyStatusState();
    form.resetFields();
    hide();
  };

  const renderStep = () => {
    const StepComponent = currentStep?.component;
    if (StepComponent) {
      return (
        <StepComponent
          setAccountFraudStatus={setAccountFraudStatus}
          accountStatusMutation={accountStatusMutation}
          closeModal={closeModal}
          form={form}
        />
      );
    }
  };

  return (
    <Modal {...modalProps} onCancel={closeModal} footer={null}>
      <div>{renderStep()}</div>
    </Modal>
  );
};

export default ApplyStatusModal;
